/* eslint-disable eol-last */
<template>

    <div>
      <div class=".cui-loading__container--organization-list" v-if="spinner">
    <div class="cui-loading--center"><div class="cui-loading"></div></div>
  </div>
     <div class="cui-wizard__field-row">
    <!-- First Name -->
    <div class="cui-wizard__field-container cui-wizard__field-container--half">
      <label for="user-name-given">{{$vuetify.lang.t('$vuetify.cui-first-name')}}</label>
      <div class="cui-error" v-if="$v.userProfile.name.given.$error && !$v.userProfile.name.given.required" >
        <div class="cui-error__message">{{$vuetify.lang.t('$vuetify.cui-this-field-is-required')}}</div>
      </div>
      <input type="text" v-model="userProfile.name.given" @blur="$v.userProfile.name.given.$touch()"
       name="given" class="cui-input"/>
    </div>

    <!-- Last Name -->
    <div class="cui-wizard__field-container cui-wizard__field-container--half">
      <label for="user-name-surname">{{$vuetify.lang.t('$vuetify.cui-last-name' )}}</label>
    <div class="cui-error" v-if="$v.userProfile.name.surname.$error && !$v.userProfile.name.surname.required" >
        <div class="cui-error__message">{{$vuetify.lang.t('$vuetify.cui-this-field-is-required')}}</div>
      </div>
      <input type="text"  @blur="$v.userProfile.name.surname.$touch()" v-model="userProfile.name.surname" name="surname" class="cui-input"/>
    </div>
  </div>

    <!-- Second Row -->

         <div class="cui-wizard__field-row">
    <!-- e-mail -->
    <div class="cui-wizard__field-container cui-wizard__field-container--half">
      <label>{{$vuetify.lang.t('$vuetify.cui-email')}}</label>
       <div class="cui-error" v-if="$v.userProfile.email.$error && !$v.userProfile.email.required" >
        <div class="cui-error__message">{{$vuetify.lang.t('$vuetify.cui-this-field-is-required')}}</div>
      </div>
      <div class="cui-error" v-else-if="$v.userProfile.email.$error && !$v.userProfile.email.isUnique" >
        <div class="cui-error__message">{{$vuetify.lang.t('$vuetify.cui-error-email-exists')}}</div>
      </div>
      <div class="cui-error" v-if="$v.userProfile.email.$error && !$v.userProfile.email.email" >
        <div class="cui-error__message">{{$vuetify.lang.t('$vuetify.cui-this-is-not-valid-email')}}</div>
      </div>
      <input type="text"  @blur="$v.userProfile.email.$touch()"  v-model="userProfile.email" name="email" class="cui-input"/>
    </div>

    <!-- Re enter e-mail-->
    <div class="cui-wizard__field-container cui-wizard__field-container--half">
      <label >{{$vuetify.lang.t('$vuetify.cui-email-re' )}}</label>
      <div class="cui-error" v-if="$v.userProfile.emailRe.$error && !$v.userProfile.emailRe.required" >
        <div class="cui-error__message">{{$vuetify.lang.t('$vuetify.cui-this-field-is-required')}}</div>
      </div>
      <div class="cui-error" v-else-if="$v.userProfile.emailRe.$error && !$v.userProfile.emailRe.sameAsEmail" >
        <div class="cui-error__message">{{$vuetify.lang.t('$vuetify.email-mismatch')}}</div>
      </div>
      <input type="text"  @blur="$v.userProfile.emailRe.$touch()"  v-model="userProfile.emailRe" name="emailRe" class="cui-input"/>
    </div>
  </div>
  <!-- Third row -->
  <div class="cui-wizard__field-row">
      <!-- Country -->
    <div class="cui-wizard__field-container cui-wizard__field-container--half">
      <label>{{$vuetify.lang.t('$vuetify.cui-country')}}</label>
     <div class="cui-error" v-if="$v.userProfile.addresses.country.$error && !$v.userProfile.addresses.country.required">
        <div class="cui-error__message">{{$vuetify.lang.t('$vuetify.cui-this-field-is-required')}}</div>
      </div>
      <autocomplete base-class="cui" name="country" :search="search" @submit="onSubmit"></autocomplete>
    </div>

       <!-- Address 1 -->
      <div class="cui-wizard__field-container cui-wizard__field-container--half">
      <label >{{$vuetify.lang.t('$vuetify.cui-street-address')}} 1</label>
      <div class="cui-error" v-if="$v.userProfile.address1.$error && !$v.userProfile.address1.required" >
        <div class="cui-error__message">{{$vuetify.lang.t('$vuetify.cui-this-field-is-required')}}</div>
      </div>
      <input type="text" @blur="$v.userProfile.address1.$touch()"  v-model="userProfile.address1" name="address1" class="cui-input"/>
    </div>
  </div>

   <!-- Fourth row -->
  <div class="cui-wizard__field-row">
    <!-- Address 2 -->
    <div class="cui-wizard__field-container cui-wizard__field-container--half">
      <label >{{$vuetify.lang.t('$vuetify.cui-address')}} 2</label>
      <input type="text"  v-model="userProfile.address2" class="cui-input" name="address2">
    </div>

    <!-- City -->
    <div class="cui-wizard__field-container cui-wizard__field-container--half">
      <label>{{$vuetify.lang.t('$vuetify.cui-city')}}</label>
      <input type="text" v-model="userProfile.addresses.city" class="cui-input" name="city"/>
    </div>
  </div>

    <!-- Fifth row -->
  <div class="cui-wizard__field-row">
    <!-- State/Province -->
    <div class="cui-wizard__field-container cui-wizard__field-container--half">
      <label>{{$vuetify.lang.t('$vuetify.cui-state')}}</label>
      <input type="text" v-model="userProfile.addresses.state" class="cui-input" name="state"/>
    </div>

    <!-- Postal Code -->
    <div class="cui-wizard__field-container cui-wizard__field-container--half">
      <label for="postal-code">{{$vuetify.lang.t('$vuetify.cui-postal')}}</label>
      <input type="text" v-model="userProfile.addresses.postal" class="cui-input" name="postal"/>
    </div>
  </div>

    <!-- Sixth row -->
  <div class="cui-wizard__field-row">
    <!-- Telephone number -->
    <div class="cui-wizard__field-container cui-wizard__field-container--half">
      <label>{{$vuetify.lang.t('$vuetify.cui-telephone')}}</label>
      <div class="cui-error" v-if="$v.userProfile.phones.number.$error && !$v.userProfile.phones.number.required" >
         <div class="cui-error__message">{{$vuetify.lang.t('$vuetify.cui-this-field-is-required')}}</div>
      </div>
      <input type="text"  @blur="$v.userProfile.phones.number.$touch()" v-model="userProfile.phones.number" class="cui-input" name="telephone"/>
    </div>
    <!--Language Preference-->
    <div class="cui-wizard__field-container cui-wizard__field-container--half">
        <label>{{$vuetify.lang.t('$vuetify.cui-language')}}</label>
        <select class="cui-dropdown" v-model="userProfile.language" name="language">
        <option
          v-for="entry in languages"
          :key="entry.language"
          :value="entry.language"
        >{{ entry.title }}</option>
      </select>
    </div>
  </div>
  <div class="cui-wizard__field-row">
    <!-- Timezone -->
    <div class="cui-wizard__field-container cui-wizard__field-container--half">
        <label for="timezone">{{$vuetify.lang.t('$vuetify.cui-timezone' )}}</label>
        <select
        class="cui-dropdown"
        v-model="userProfile.timezone" name="language" >
        <option
          v-for="entry in timezones"
          :key="entry.id"
          :value="entry.id"
        >{{ entry.name }}</option>
      </select>
    </div>
  </div>
    <!-- TOS -->
    <!-- TOS -->
  <div class='cui-tos-container'>
    <input type="checkbox" name="TOS" id="TOS"  @click="$v.userProfile.tos.$touch()" v-model="userProfile.tos">
   <label>{{$vuetify.lang.t('$vuetify.cui-agree-covisint')}}
      <a href="" class="cui-link cui-padding--h-5">{{$vuetify.lang.t('$vuetify.terms-of-service')}}</a> {{$vuetify.lang.t('$vuetify.cui-and')}}
      <a href="" class="cui-link cui-padding--h-5">{{$vuetify.lang.t('$vuetify.privacy-policy')}}</a>
    </label>
    <div v-if="$v.userProfile.tos.$error && !$v.userProfile.tos.required">
    <span class="cui-wizard__step-error"><br/><br/> {{$vuetify.lang.t('$vuetify.cui-tos-agree' )}} </span>
    </div>
  </div>
    </div>
</template>
<script>
// eslint-disable-next-line no-unused-vars
import Vuelidate from 'vuelidate'
// eslint-disable-next-line standard/object-curly-even-spacing
import { required, email, sameAs} from 'vuelidate/lib/validators'
import Autocomplete from '@trevoreyre/autocomplete-vue'
import '@trevoreyre/autocomplete-vue/dist/style.css'
import { languages } from '@/plugins/factory/Language'
import Countries from '@/plugins/factory/Countries'
import Timezones from '@/plugins/factory/Timezones'
export default {
  data () {
    return {
      spinner: false,
      userProfile: {
        name: {
          given: '',
          surname: ''
        },
        email: '',
        address1: '',
        address2: '',
        addresses: {
          country: '',
          city: '',
          state: '',
          postal: ''
        },
        phones: {number: '', type: 'main'},
        language: this.$store.getters.getCurrentLanguage,
        timezone: 'Pacific/Fiji'
      },
      inlineError: false,
      countries: Countries.countries,
      timezones: Timezones.timezones,
      languages: languages,
      submitted: false
    }
  },

  validations: {
    userProfile: {
      name: {
        given: {
          required
        },
        surname: {
          required
        }
      },
      email: {
        required,
        isUnique (value) {
        // return true
          return new Promise((resolve, reject) => {
            this.spinner = true
            this.$API.initiateNonce().then(res => {
              this.$API.validateUsernameEmailNonce({qs: [['emailAddress', value]]})
                .then(res => {
                  this.spinner = false
                  resolve(true)
                })
                .fail(error => {
                  this.spinner = false
                  console.log(error)
                  resolve(false)
                })
            })
              .fail(error => {
                this.spinner = false
                console.log(error)
                resolve(false)
              })
          })
        },
        email
      },
      emailRe: {
        required,
        sameAsEmail: sameAs(function () { return this.userProfile.email })
      },
      addresses: {
        country: {
          required
        }
      },
      address1: {
        required
      },
      phones: {
        number: {
          required
        }
      },
      tos: {
        required
      }
    },
    form: ['userProfile.name.given', 'userProfile.name.surname', 'userProfile.email', 'userProfile.emailRe',
      'userProfile.address1', 'userProfile.phones.number', 'userProfile.tos']
  },
  components: {
    Vuelidate,
    Autocomplete
  },
  methods: {
    validate () {
      this.$v.form.$touch()
      var isValid = !this.$v.form.$invalid
      this.$emit('on-validate', this.$data, isValid)
      return isValid
    },
    search (input) {
      if (input.length < 1) {
        return []
      }
      const countriesJson = this.countries.filter(country => {
        if (country.name.toLowerCase().startsWith(input.toLowerCase())) {
          return country.name
        }
      })
      var countriesName = []
      countriesJson.forEach((obj) => {
        countriesName.push(obj.name)
      })
      return countriesName
    },
    onSubmit (result) {
      this.userProfile.addresses.country = result
    }
  }

}
</script>>



// WEBPACK FOOTER //
// src/components/pages/registration/userProfile.vue